import { WORKFLOW_EVENT_TYPE } from '@/constants';
import i18n from '@/assets/i18n/translate-message';

const getSummaryWorkflowStatus = ({
  clusterName,
  isWorkflowRunning,
  workflow,
  workflowCompletedEvent,
}) => {
  if (isWorkflowRunning) {
    return 'running';
  }

  if (!workflowCompletedEvent) {
    return (
      (workflow && workflow.workflowExecutionInfo.closeStatus)
      || 'running'
    ).toLowerCase();
  }

  if (
    workflowCompletedEvent.eventType
    === WORKFLOW_EVENT_TYPE.WorkflowExecutionContinuedAsNew
  ) {
    return {
      to: {
        name: 'workflow/summary',
        params: {
          clusterName,
          runId: workflowCompletedEvent.details.newExecutionRunId,
        },
      },
      text: i18n.t('dj-重新开始'),
      status: 'continued-as-new',
    };
  }

  return workflowCompletedEvent.eventType
    .replace('WorkflowExecution', '')
    .toLowerCase();
};

export default getSummaryWorkflowStatus;
